import React from "react";

import { Text, View } from "react-native";

export const KDActions = ({ navigation }) => {
  return <View><Text>Reportings</Text></View>;
};
